import { Button, notification, Upload } from "antd";
import { useUploadEdiFileMutation } from "shared/api/ediApi";
import React from "react";
import { useTranslation } from "react-i18next";
import { Page } from "shared/ui";
import EdiTableView from "./ui/EdiTableView";

const EdiPage = () => {
  const { t } = useTranslation();
  const [uploadEdiFile, { isLoading }] = useUploadEdiFileMutation();
  const [api, contextHolder] = notification.useNotification();

  const handleUpload = async (file: File) => {
    try {
      await uploadEdiFile({ file }).unwrap();
      api.success({
        message: "File uploaded successfully",
      });
    } catch (e) {
      api.error({
        message: "Failed to upload file",
      });
    }
  };

  return (
    <>
      {contextHolder}
      <Page title={t("edi-page.title")}>
        <Upload
          beforeUpload={(file) => {
            handleUpload(file);
            return false;
          }}
          showUploadList={false}
        >
          <Button type="default" loading={isLoading}>
            {t("Upload File")}
          </Button>
        </Upload>

        <EdiTableView />
      </Page>
    </>
  );
};

export { EdiPage };
